//natives
import React, { Component } from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
// import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
// import Typography from '@material-ui/core/Typography';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Media from 'react-media';
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Select from '@material-ui/core/Select';
// import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from "@material-ui/core/CircularProgress";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import DatePicker from "react-datepicker";

//css
import css from './css';
const useStyles = css();

export default (props) => {
    const classes = useStyles();

    const handlerChangeFornec = (e,v) => {
        props.props.setState({fornecedor: v.ID_PESSOA});
    };

    const handleChangeNota = (e,v) => {
        props.props.setState({tipoNota: v.id});
    };

    const tipos_filtro = [
        {desc: "Todos"},
        {desc: "Pendentes"},
        {desc: "Pagos"}
    ];

    const tipos_notas = [
        // {id: "C",name:"Compra"},
        {id: "D",name:"Devolução"},
        {id: "P",name:"Pedidos"},
    ];

    return (
        <div id={"filtroAdm"}>
            {   (props.permissions['filtro-fornecedor'] || 
                props.props.state.filters.datas == true ||
                props.props.state.filters.flagsPag == true) &&
                <div className={classes.root}>
                    <ExpansionPanel>
                        <ExpansionPanelDetails>
                            <Media query="(min-width: 1200px)">
                                {matches =>
                                    matches ? (
                                        <Box className={classes.flexContainer}>
                                            {props.permissions['filtro-fornecedor'] &&
                                                <Box>
                                                    {props.state.fornecedores == null &&
                                                        <CircularProgress/>
                                                    }
                                                    {props.state.fornecedores != null && props.state.fornecedores.length > 0 &&
                                                        <Autocomplete
                                                            id="lb_id_adminFilter"
                                                            style={{width: 450}}
                                                            options={props.state.fornecedores}
                                                            getOptionLabel={o => o.ID_PESSOA+' - '+o.NM_PESSOA}
                                                            onChange={handlerChangeFornec}
                                                            loadingText={"Carregando..."}
                                                            renderInput={params => (
                                                                <TextField
                                                                    {...params}
                                                                    variant={"standard"}
                                                                    label={"Selecione o fornecedor"}
                                                                    placeholder={"Fornecedor Lta."}
                                                                    fullWidth
                                                                />
                                                            )}
                                                        />
                                                    }
                                                </Box>
                                            }
                                            {props.props.state.filters.notas != null &&
                                                <Autocomplete
                                                    id="lb_id_notas"
                                                    style={{width: 200}}
                                                    options={tipos_notas}
                                                    getOptionLabel={o => o.name}
                                                    onChange={handleChangeNota}
                                                    loadingText={"Carregando..."}
                                                    renderInput={params => (
                                                        <TextField
                                                            {...params}
                                                            variant={"standard"}
                                                            label={"Selecione o tipo de nota"}
                                                            placeholder={"Devolução"}
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            }
                                            {props.props.state.filters.datas == true &&
                                                <Box className={classes.dtBox}>
                                                    <DatePicker
                                                        selected={props.state.dataInicio}
                                                        locale="pt"
                                                        dateFormat="dd/MM/yyyy"
                                                        onChange={(data) => {props.setState({dataInicio:data})}}
                                                        customInput={
                                                            <TextField
                                                                variant={"standard"}
                                                                label={"Data início"}
                                                                placeholderText="dd/mm/aaaa"
                                                                value={props.state.dataInicio}
                                                                fullWidth
                                                            />
                                                        }
                                                    />
                                                </Box>
                                            }
                                            {props.props.state.filters.datas == true &&
                                                <Box className={classes.dtBox}>
                                                    <DatePicker
                                                        selected={props.state.dataFim}
                                                        locale="pt"
                                                        dateFormat="dd/MM/yyyy"
                                                        onChange={(data) => {props.setState({dataFim:data})}}
                                                        customInput={
                                                            <TextField
                                                                variant={"standard"}
                                                                label={"Data fim"}
                                                                placeholderText="dd/mm/aaaa"
                                                                value={props.state.dataFim}
                                                                fullWidth
                                                            />
                                                        }
                                                        minDate={props.state.dataInicio}
                                                    />
                                                </Box>
                                            }
                                            {props.props.state.filters.flagsPag == true &&
                                                <Box style={{marginRight: 16}}>
                                                    <Autocomplete
                                                        id="flagFilter"
                                                        style={{width: 150}}
                                                        options={tipos_filtro}
                                                        getOptionLabel={o => o.desc}
                                                        getOptionSelected={(option, value) => {
                                                            return option.title === value.title;
                                                        }}
                                                        onChange={(e,v)=>{
                                                            if (v!=null)
                                                                props.props.setState({flagFilter:v.desc})
                                                        }}
                                                        loadingText={"Carregando..."}
                                                        defaultValue={tipos_filtro[0]}
                                                        renderInput={params => (
                                                            <TextField
                                                                {...params}
                                                                variant={"standard"}
                                                                label={"Tipo"}
                                                                placeholder={"Todos"}
                                                                fullWidth
                                                            />
                                                        )}
                                                    />
                                                </Box>
                                            }
                                            <Box className={classes.aplicar}>
                                                <Button 
                                                    variant="contained" 
                                                    color="primary" 
                                                    className={classes.button} 
                                                    onClick={()=>{props.sendRequest(props)}}
                                                >                                        
                                                    Aplicar
                                                </Button>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <div align={'center'} style={{width:'100%'}}>
                                            {props.permissions['filtro-fornecedor'] &&
                                                <div style={{width:'100%'}}>
                                                    <br/><br/>
                                                    {props.state.fornecedores == null &&
                                                        <CircularProgress />
                                                    }
                                                    {props.state.fornecedores != null && props.state.fornecedores.length > 0 &&
                                                        <Autocomplete
                                                            id="lb_id_adminFilter"
                                                            style={{width: "30%"}}
                                                            options={props.state.fornecedores}
                                                            getOptionLabel={o => o.ID_PESSOA+' - '+o.NM_PESSOA}
                                                            onChange={handlerChangeFornec}
                                                            loadingText={"Carregando..."}
                                                            renderInput={params => (
                                                                <TextField
                                                                    {...params}
                                                                    variant={"standard"}
                                                                    label={"Selecione o fornecedor"}
                                                                    placeholder={"Fornecedor Lta."}
                                                                    fullWidth
                                                                />
                                                            )}
                                                        />
                                                    }
                                                    {props.props.state.filters.notas != null &&
                                                        <Autocomplete
                                                            id="lb_id_notas"
                                                            style={{width: 200}}
                                                            options={tipos_notas}
                                                            getOptionLabel={o => o.name}
                                                            onChange={handleChangeNota}
                                                            loadingText={"Carregando..."}
                                                            renderInput={params => (
                                                                <TextField
                                                                    {...params}
                                                                    variant={"standard"}
                                                                    label={"Selecione o tipo de nota"}
                                                                    placeholder={"Devolução"}
                                                                    fullWidth
                                                                />
                                                            )}
                                                        />
                                                    }
                                                </div>
                                            }
                                            {props.props.state.filters.datas == true &&
                                                <div style={{width:'100%'}}>
                                                    <label className={classes.labels}>Data início</label>
                                                    <DatePicker
                                                        selected={props.state.dataInicio}
                                                        onChange={(data) => {props.setState({dataInicio:data})}}
                                                        value={props.state.dataInicio}
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="dd/mm/aaaa"
                                                        locale="pt"
                                                    />
                                                </div>
                                            }
                                            {props.props.state.filters.datas == true &&
                                                <div style={{width:'100%'}}>
                                                    <br/><br/>
                                                    <label className={classes.labels}>Data fim</label>
                                                    <DatePicker
                                                        selected={props.state.dataFim}
                                                        onChange={(data) => {props.setState({dataFim:data})}}
                                                        value={props.state.dataFim}
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="dd/mm/aaaa"
                                                        locale="pt"
                                                        minDate={props.state.dataInicio}
                                                    />
                                                </div>
                                            }
                                            {props.props.state.filters.flagsPag == true &&
                                                <div style={{width:'100%'}}>
                                                    <br/><br/>
                                                    <Autocomplete
                                                        id="flagFilter"
                                                        style={{width: 150}}
                                                        options={tipos_filtro}
                                                        getOptionLabel={o => o.desc}
                                                        getOptionSelected={(option, value) => {
                                                            return option.title === value.title;
                                                        }}
                                                        onChange={(e,v)=>{
                                                            if (v!=null)
                                                                props.props.setState({flagFilter:v.desc})
                                                        }}
                                                        loadingText={"Carregando..."}
                                                        defaultValue={tipos_filtro[0]}
                                                        renderInput={params => (
                                                            <TextField
                                                                {...params}
                                                                variant={"standard"}
                                                                label={"Tipo"}
                                                                placeholder={"Todos"}
                                                                fullWidth
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            }
                                            <br/><br/>
                                            <Button variant="contained" color="primary" className={classes.button} onClick={()=>{props.sendRequest(props)}}>
                                                <Icon className={classes.rightIcon}>search</Icon>
                                                Aplicar
                                            </Button>
                                        </div>
                                    )
                                }
                            </Media>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
            }
        </div>
    );
}